import { useEffect, useState } from 'react';
import bloodImg from '../assets/blood.png';
import styles from './BloodSplash.module.css';

type Props = {
  triggerCount: number;
};

export function BloodSplash({ triggerCount }: Props) {
  const [visible, setVisible] = useState(false);
  const [key, setKey] = useState(0);
  const [side, setSide] = useState<'left' | 'right'>('left');

  useEffect(() => {
    if (triggerCount === 0) return;
    setSide(Math.random() < 0.5 ? 'left' : 'right');
    setKey((k) => k + 1);
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 1200);
    return () => clearTimeout(t);
  }, [triggerCount]);

  if (!visible) return null;

  return (
    <div
      key={key}
      className={side === 'left' ? styles.overlayLeft : styles.overlayRight}
    >
      <img
        src={bloodImg}
        className={side === 'right' ? `${styles.blood} ${styles.bloodFlipped}` : styles.blood}
        alt=""
      />
    </div>
  );
}
